import React, { PureComponent } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Dropdown, Menu, Progress } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { getInfoByFileName } from './utils';
import './Attachment.scss';
class Attachment extends PureComponent {
  constructor() {
    super(...arguments);
    this.handlePreview = e => {
      e.preventDefault();
      const {
        onPreview,
        file
      } = this.props;
      onPreview(file, e);
    };
    this.handleDelete = e => {
      e.preventDefault();
      const {
        onDeleteFile,
        file
      } = this.props;
      onDeleteFile(file, e);
    };
    this.onClickDownload = e => {
      const {
        file,
        showThumbnail,
        downloadAttachmentWithPresignedUrl
      } = this.props;
      if (!showThumbnail) {
        downloadAttachmentWithPresignedUrl(file.url);
        e.stopPropagation();
      }
    };
    this.renderActions = () => {
      const {
        file,
        canDelete,
        onPreview,
        showThumbnail
      } = this.props;
      return /*#__PURE__*/React.createElement(Menu, {
        className: "commentActions__menu"
      }, canDelete && /*#__PURE__*/React.createElement(Menu.Item, null, /*#__PURE__*/React.createElement("a", {
        href: "",
        role: "button",
        tabIndex: "0",
        onClick: this.handleDelete
      }, __('Delete Attachment'))), onPreview && /*#__PURE__*/React.createElement(Menu.Item, null, /*#__PURE__*/React.createElement("a", {
        href: "",
        role: "button",
        tabIndex: "0",
        onClick: this.handlePreview
      }, __('Preview'))), /*#__PURE__*/React.createElement(Menu.Item, null, !showThumbnail ? /*#__PURE__*/React.createElement("span", {
        onClick: e => this.onClickDownload(e)
      }, __('Download')) : /*#__PURE__*/React.createElement("a", {
        href: file.url,
        onClick: e => e.stopPropagation()
      }, __('Download'))));
    };
    this.renderOverlay = () => {
      return /*#__PURE__*/React.createElement("div", {
        className: "tap-attachment-actions"
      }, /*#__PURE__*/React.createElement(Dropdown, {
        overlay: this.renderActions,
        trigger: ['click']
      }, /*#__PURE__*/React.createElement("span", {
        className: "ant-dropdown-link",
        onClick: e => {
          e.preventDefault();
          e.stopPropagation();
        },
        role: "button",
        tabIndex: "0"
      }, /*#__PURE__*/React.createElement(DownOutlined, null))));
    };
  }
  render() {
    const {
      file,
      showMeta,
      onClick,
      showThumbnail
    } = this.props;
    const {
      icon,
      type
    } = getInfoByFileName(file.name || file.url);
    const attachmentClass = cx('tap-attachment', {
      'tap-attachment-thumbnail-container': type === 'Image'
    });
    return /*#__PURE__*/React.createElement("div", {
      className: attachmentClass,
      role: "button",
      tabIndex: "0"
    }, this.renderOverlay(), type === 'Image' && showThumbnail ? /*#__PURE__*/React.createElement("div", {
      className: "tap-attachment-thumbnail",
      role: "button",
      tabIndex: "0",
      onClick: onClick
    }, file.percent !== undefined ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "tap-attachment-name"
    }, file.name), /*#__PURE__*/React.createElement(Progress, {
      percent: file.percent
    })) : /*#__PURE__*/React.createElement("img", {
      src: file.thumbUrl || file.url,
      alt: file.name
    })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "tap-attachment-icon tap-attachment-icon-".concat(icon.color || 'default')
    }, icon.render ? icon.render() : /*#__PURE__*/React.createElement("svg", {
      viewBox: icon.viewBox
    }, /*#__PURE__*/React.createElement("path", {
      d: icon.path
    }))), /*#__PURE__*/React.createElement("div", {
      className: "tap-attachment-info",
      role: "button",
      tabIndex: "0",
      onClick: onClick
    }, /*#__PURE__*/React.createElement("div", {
      className: "tap-attachment-name"
    }, file.name), file.percent === undefined && showMeta && /*#__PURE__*/React.createElement("div", {
      className: "tap-attachment-meta"
    }, /*#__PURE__*/React.createElement("span", {
      className: "tap-attachment-type"
    }, "".concat(type, " - ")), !showThumbnail ? /*#__PURE__*/React.createElement("span", {
      className: "tap-attachment-span-style",
      onClick: e => this.onClickDownload(e)
    }, __('Download')) : /*#__PURE__*/React.createElement("a", {
      href: file.url,
      onClick: e => e.stopPropagation()
    }, __('Download'))), file.percent !== undefined ? /*#__PURE__*/React.createElement(Progress, {
      percent: file.percent
    }) : null)));
  }
}
Attachment.propTypes = {
  file: PropTypes.object.isRequired,
  showMeta: PropTypes.bool,
  canDelete: PropTypes.bool,
  onClick: PropTypes.func,
  onDeleteFile: PropTypes.func,
  onPreview: PropTypes.func,
  showThumbnail: PropTypes.bool
};
Attachment.defaultProps = {
  showThumbnail: true,
  showMeta: true,
  canDelete: false,
  onClick: null,
  onDeleteFile: null,
  onPreview: null
};
export default Attachment;